module.exports = __webpack_public_path__ + "img/part_right_icon.b5aea618.svg";